export default __webpack_public_path__ + "static/media/shoes1-afterA.e63a8b32.jpg";